/*=========================================================================================
  File Name: moduleCustomFieldState.js
  Description: Custom Field Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  customerPaymentMethods: [],
}